import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var __Array = {
    checkboxGroupOptions: '_checkboxGroup',
    tagsOptions: '_tags',
    servicesCheckboxGroupOptions: '_servicesCheckboxGroup',
    validation: '_validationArrayType',
};
var __Boolean = { checkboxOptions: '_checkbox' };
var __Number = {
    numberInputOptions: '_numberInput',
    ratingInputOptions: '_ratingInput',
    validation: '_validationNumberType',
};
var __Object = { validation: '_validationObjectType' };
var __String = {
    textInputOptions: '_textInput',
    radioGroupOptions: '_radioGroup',
    dropdownOptions: '_dropdown',
    dateTimeOptions: '_dateTimeInput',
    phoneInputOptions: '_phoneInput',
    dateInputOptions: '_dateInput',
    timeInputOptions: '_timeInput',
    datePickerOptions: '_datePicker',
};
var _address = { multilineAddressOptions: '_multilineAddress' };
var _andCondition = { conditions: '_conditionNode' };
var _appEmbedData = { image: '_media' };
var _appointment = { description: '_richContent' };
var _array = {
    checkboxGroupOptions: '_checkboxGroup',
    tagsOptions: '_tags',
    servicesCheckboxGroupOptions: '_servicesCheckboxGroup',
    validation: '_inputFieldArrayType',
};
var _arrayItems = { number: '_numberType', object: '_objectType' };
var _arrayType = { items: '_arrayItems' };
var _arrayTypeArrayItems = {
    numberOptions: '_inputFieldNumberType',
    objectOptions: '_inputFieldObjectType',
};
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _backgroundImage = { media: '_media' };
var _boolean = { checkboxOptions: '_checkbox' };
var _breakPoint = { items: '_itemLayout' };
var _bulkCloneFormRequest = {};
var _bulkCloneFormResponse = { results: '_bulkFormResult' };
var _bulkCreateFormRequest = { forms: '_form' };
var _bulkCreateFormResponse = { results: '_bulkFormResult' };
var _bulkDeleteFormRequest = {};
var _bulkDeleteFormResponse = { results: '_bulkFormResult' };
var _bulkFormResult = { item: '_form' };
var _bulkRemoveDeletedFieldRequest = {};
var _bulkRemoveDeletedFieldResponse = { form: '_form' };
var _bulkUpdateFormTagsByFilterRequest = {};
var _bulkUpdateFormTagsByFilterResponse = {};
var _bulkUpdateFormTagsRequest = {};
var _bulkUpdateFormTagsResponse = {};
var _checkbox = { label: '_richContent' };
var _checkboxGroup = {
    description: '_richContent',
    options: '_option',
    media: '_mediaItem',
};
var _cloneFormFromTemplateRequest = {};
var _cloneFormFromTemplateResponse = { form: '_form' };
var _cloneFormRequest = {};
var _cloneFormResponse = { form: '_form' };
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _conditionNode = { and: '_andCondition', or: '_orCondition' };
var _countDeletedFormsRequest = {};
var _countDeletedFormsResponse = {};
var _countFormsByFilterRequest = {};
var _countFormsByFilterResponse = {};
var _countFormsRequest = {};
var _countFormsResponse = {};
var _createFormRequest = { form: '_form' };
var _createFormResponse = { form: '_form' };
var _createMigratedFormRequest = { form: '_form' };
var _createMigratedFormResponse = { form: '_form' };
var _dateInput = { description: '_richContent', media: '_mediaItem' };
var _datePicker = { description: '_richContent', media: '_mediaItem' };
var _dateTimeInput = { description: '_richContent', media: '_mediaItem' };
var _deleteFormRequest = {};
var _deleteFormResponse = {};
var _design = { poll: '_pollDesign' };
var _displayField = { richContentOptions: '_richContentOptions' };
var _donationInput = { description: '_richContent', media: '_mediaItem' };
var _dropdown = { description: '_richContent', media: '_mediaItem' };
var _fieldsDisplayField = { richContentOptions: '_fieldsRichContentOptions' };
var _fieldsField = {
    inputOptions: '_fieldsInputField',
    displayOptions: '_fieldsDisplayField',
};
var _fieldsInputField = {
    stringOptions: '__String',
    numberOptions: '__Number',
    booleanOptions: '__Boolean',
    arrayOptions: '__Array',
    objectOptions: '__Object',
    wixFileOptions: '_inputFieldWixFile',
    paymentOptions: '_inputFieldPayment',
    schedulingOptions: '_inputFieldScheduling',
    addressOptions: '_address',
    multilineAddressOptions: '_address',
    objectArrayOptions: '_objectArray',
};
var _fieldsRichContentOptions = { richContent: '_richContent' };
var _fileUpload = { description: '_richContent', media: '_mediaItem' };
var _fixedPayment = { description: '_richContent', media: '_mediaItem' };
var _form = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: '_formField',
    fieldsV2: '_formFieldV2',
    formFields: '_fieldsField',
    steps: '_step',
    deletedFields: '_formField',
    deletedFieldsV2: '_formFieldV2',
    deletedFormFields: '_fieldsField',
    nestedForms: '_nestedForm',
    limitationRule: '_limitationRule',
    submitSettings: '_submitSettings',
    disabledFormMessage: '_richContent',
    formRules: '_rule',
};
var _formField = { validation: '_validation' };
var _formFieldV2 = {
    inputOptions: '_inputField',
    displayOptions: '_displayField',
};
var _formLayout = {
    large: '_breakPoint',
    medium: '_breakPoint',
    small: '_breakPoint',
};
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getDeletedFormRequest = {};
var _getDeletedFormResponse = { form: '_form' };
var _getFormRequest = {};
var _getFormResponse = { form: '_form' };
var _getFormSummaryRequest = {};
var _getFormSummaryResponse = {};
var _group = { items: '_itemLayout' };
var _image = { media: '_media' };
var _imageData = { image: '_media' };
var _inputField = {
    stringOptions: '_string',
    numberOptions: '_number',
    booleanOptions: '_boolean',
    arrayOptions: '_array',
    objectOptions: '_object',
    wixFileOptions: '_wixFile',
    paymentOptions: '_payment',
    multilineAddressOptions: '_inputFieldMultilineAddress',
    schedulingOptions: '_scheduling',
};
var _inputFieldArrayType = { items: '_arrayTypeArrayItems' };
var _inputFieldMultilineAddress = {
    multilineAddressOptions: '_multilineAddress',
};
var _inputFieldNumberType = {
    maximum: 'google.protobuf.DoubleValue',
    minimum: 'google.protobuf.DoubleValue',
    multipleOf: 'google.protobuf.DoubleValue',
    enum: 'google.protobuf.DoubleValue',
};
var _inputFieldObjectType = { properties: 'Map#_objectTypePropertiesType' };
var _inputFieldPayment = {
    checkboxGroupOptions: '_productCheckboxGroup',
    donationInputOptions: '_donationInput',
    paymentInputOptions: '_paymentInput',
    fixedPaymentOptions: '_fixedPayment',
};
var _inputFieldScheduling = { appointmentOptions: '_appointment' };
var _inputFieldWixFile = {
    fileUploadOptions: '_fileUpload',
    signatureOptions: '_signature',
};
var _item = { image: '_image', video: '_video' };
var _itemLayout = { group: '_group' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _layoutData = {
    backgroundImage: '_backgroundImage',
    backdropImage: '_backgroundImage',
};
var _limitationRule = { dateTimeDeadline: 'google.protobuf.Timestamp' };
var _listDeletedFormsRequest = {};
var _listDeletedFormsResponse = { forms: '_form' };
var _listFormsProvidersConfigsRequest = {};
var _listFormsProvidersConfigsResponse = {};
var _listFormsRequest = {};
var _listFormsResponse = { forms: '_form' };
var _listTemplateExtensionsRequest = {};
var _listTemplateExtensionsResponse = { forms: '_form' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _mediaItem = { image: '_commonImage' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _multilineAddress = { description: '_richContent' };
var _nestedForm = { form: '_form' };
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    layoutData: '_layoutData',
    nodes: '_node',
};
var _number = {
    numberInputOptions: '_numberInput',
    ratingInputOptions: '_ratingInput',
    validation: '_inputFieldNumberType',
};
var _numberInput = {
    default: 'google.protobuf.DoubleValue',
    description: '_richContent',
    media: '_mediaItem',
};
var _numberType = {
    maximum: 'google.protobuf.DoubleValue',
    minimum: 'google.protobuf.DoubleValue',
    multipleOf: 'google.protobuf.DoubleValue',
    enum: 'google.protobuf.DoubleValue',
};
var _object = { object: '_inputFieldObjectType' };
var _objectArray = { repeaterOptions: '_repeater' };
var _objectType = { properties: 'Map#_propertiesType' };
var _objectTypePropertiesType = {
    numberOptions: '_inputFieldNumberType',
    arrayOptions: '_inputFieldArrayType',
};
var _option = { media: '_mediaItem' };
var _orCondition = { conditions: '_conditionNode' };
var _payment = {
    checkboxGroupOptions: '_productCheckboxGroup',
    donationInputOptions: '_donationInput',
    paymentInputOptions: '_paymentInput',
    fixedPaymentOptions: '_fixedPayment',
};
var _paymentInput = {
    default: 'google.protobuf.DoubleValue',
    description: '_richContent',
    media: '_mediaItem',
};
var _phoneInput = { description: '_richContent', media: '_mediaItem' };
var _poll = { image: '_media', options: '_pollOption' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _pollOption = { image: '_media' };
var _productCheckboxGroup = {
    description: '_richContent',
    options: '_productCheckboxGroupOption',
    media: '_mediaItem',
};
var _productCheckboxGroupOption = { media: '_mediaItem' };
var _propertiesType = { number: '_numberType', array: '_arrayType' };
var _queryDeletedFormsRequest = {};
var _queryDeletedFormsResponse = { forms: '_form' };
var _queryFormsRequest = {};
var _queryFormsResponse = { forms: '_form' };
var _radioGroup = { description: '_richContent', media: '_mediaItem' };
var _ratingInput = { description: '_richContent', media: '_mediaItem' };
var _removeFormFromTrashBinRequest = {};
var _removeFormFromTrashBinResponse = {};
var _repeater = {
    description: '_richContent',
    fields: '_fieldsField',
    layout: '_formLayout',
};
var _restoreFromTrashBinRequest = {};
var _restoreFromTrashBinResponse = { form: '_form' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _richContentOptions = { richContent: '_richContent' };
var _rule = { expression: '_conditionNode' };
var _scheduling = { appointmentOptions: '_appointment' };
var _servicesCheckboxGroup = { description: '_richContent' };
var _signature = { description: '_richContent', media: '_mediaItem' };
var _step = { layout: '_formLayout' };
var _string = {
    textInputOptions: '_textInput',
    radioGroupOptions: '_radioGroup',
    dropdownOptions: '_dropdown',
    dateTimeOptions: '_dateTimeInput',
    phoneInputOptions: '_phoneInput',
    dateInputOptions: '_dateInput',
    timeInputOptions: '_timeInput',
    datePickerOptions: '_datePicker',
};
var _submitSettings = { thankYouMessageOptions: '_thankYouMessageOptions' };
var _tags = {
    description: '_richContent',
    options: '_tagsOption',
    media: '_mediaItem',
};
var _tagsOption = { media: '_mediaItem' };
var _textInput = { description: '_richContent', media: '_mediaItem' };
var _thankYouMessageOptions = { richContent: '_richContent' };
var _timeInput = { description: '_richContent', media: '_mediaItem' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = {};
var _updateFormRequest = { mask: 'google.protobuf.FieldMask', form: '_form' };
var _updateFormResponse = { form: '_form' };
var _validation = {
    number: '_numberType',
    array: '_arrayType',
    object: '_objectType',
};
var _validationArrayType = { items: '_validationArrayTypeArrayItems' };
var _validationArrayTypeArrayItems = {
    numberOptions: '_validationNumberType',
    objectOptions: '_validationObjectType',
};
var _validationNumberType = {
    maximum: 'google.protobuf.DoubleValue',
    minimum: 'google.protobuf.DoubleValue',
    multipleOf: 'google.protobuf.DoubleValue',
    enum: 'google.protobuf.DoubleValue',
};
var _validationObjectType = {
    properties: 'Map#_validationObjectTypePropertiesType',
};
var _validationObjectTypePropertiesType = {
    numberOptions: '_validationNumberType',
    arrayOptions: '_validationArrayType',
};
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _wixFile = {
    fileUploadOptions: '_fileUpload',
    signatureOptions: '_signature',
};
function resolveWixFormsV4FormSchemaServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/form-schema-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
            {
                srcPath: '/form-schema-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/form-schema-service',
                destPath: '',
            },
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/form-schema-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/form-schema-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a form schema.
 *
 * Each form schema defines the structure, fields, validation rules, and layout for forms.
 * The form schema serves as a blueprint that can be used by an app to generate actual forms. The app that can use the schema is determined by the specified `namespace`.
 */
export function createForm(payload) {
    var _a = serializer(_createFormRequest, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __createForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.CreateForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createForm.fromReq = fromReq;
    __createForm.__isAmbassador = true;
    return __createForm;
}
/** Creates multiple form schemas in a single request. */
export function bulkCreateForm(payload) {
    var _a = serializer(_bulkCreateFormRequest, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _bulkFormResult: _bulkFormResult,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __bulkCreateForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.BulkCreateForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/bulk/forms/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateForm.fromReq = fromReq;
    __bulkCreateForm.__isAmbassador = true;
    return __bulkCreateForm;
}
/** Creates a copy of an existing form schema with a new ID. */
export function cloneForm(payload) {
    var _a = serializer(_cloneFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __cloneForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.CloneForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/{formId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneForm.fromReq = fromReq;
    __cloneForm.__isAmbassador = true;
    return __cloneForm;
}
/** Creates copies of multiple form schemas in a single request. */
export function bulkCloneForm(payload) {
    var _a = serializer(_bulkCloneFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCloneFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _bulkFormResult: _bulkFormResult,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __bulkCloneForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.BulkCloneForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/bulk/forms/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCloneForm.fromReq = fromReq;
    __bulkCloneForm.__isAmbassador = true;
    return __bulkCloneForm;
}
/** Creates a form schema from a template. */
export function cloneFormFromTemplate(payload) {
    var _a = serializer(_cloneFormFromTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneFormFromTemplateResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __cloneFormFromTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.CloneFormFromTemplate',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/clone-from-template',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneFormFromTemplate.fromReq = fromReq;
    __cloneFormFromTemplate.__isAmbassador = true;
    return __cloneFormFromTemplate;
}
/** Retrieves a form schema by ID. */
export function getForm(payload) {
    var _a = serializer(_getFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSchemaService.GetForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/{formId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getForm.fromReq = fromReq;
    __getForm.__isAmbassador = true;
    return __getForm;
}
/** Updates a form schema. */
export function updateForm(payload) {
    var _a = serializer(_updateFormRequest, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __updateForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'PATCH',
            methodFqn: 'wix.forms.v4.FormSchemaService.UpdateForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/{form.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateForm.fromReq = fromReq;
    __updateForm.__isAmbassador = true;
    return __updateForm;
}
/** Removes a form schema from the trash bin, permanently deleting it. */
export function removeFormFromTrashBin(payload) {
    var _a = serializer(_removeFormFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeFormFromTrashBinResponse, {}).fromJSON;
    function __removeFormFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'DELETE',
            methodFqn: 'wix.forms.v4.FormSchemaService.RemoveFormFromTrashBin',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/trash-bin/{formId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeFormFromTrashBin.fromReq = fromReq;
    __removeFormFromTrashBin.__isAmbassador = true;
    return __removeFormFromTrashBin;
}
/**
 * Deletes a form schema.
 *
 * The schema is moved to the trash bin where it's stored for 90 days before permanent deletion.
 * When permanently deleted, all associated form submissions are also deleted.
 */
export function deleteForm(payload) {
    var _a = serializer(_deleteFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteFormResponse, {}).fromJSON;
    function __deleteForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'DELETE',
            methodFqn: 'wix.forms.v4.FormSchemaService.DeleteForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/{formId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteForm.fromReq = fromReq;
    __deleteForm.__isAmbassador = true;
    return __deleteForm;
}
/**
 * Deletes multiple form schemas at once.
 *
 * The schemas are moved to the trash bin where they're stored for 90 days before permanent deletion.
 * When permanently deleted, all associated form submissions are also deleted.
 */
export function bulkDeleteForm(payload) {
    var _a = serializer(_bulkDeleteFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _bulkFormResult: _bulkFormResult,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __bulkDeleteForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.BulkDeleteForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/bulk/forms/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteForm.fromReq = fromReq;
    __bulkDeleteForm.__isAmbassador = true;
    return __bulkDeleteForm;
}
/** Restores a form schema from the trash bin. It will no longer be deleted after 90 days. */
export function restoreFromTrashBin(payload) {
    var _a = serializer(_restoreFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreFromTrashBinResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __restoreFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.RestoreFromTrashBin',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/trash-bin/{formId}/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreFromTrashBin.fromReq = fromReq;
    __restoreFromTrashBin.__isAmbassador = true;
    return __restoreFromTrashBin;
}
/**
 * Retrieves a list of form schemas given the provided paging, filtering, and sorting.
 *
 * You must specify a namespace equality filter. For example, `"namespace:{"$eq":"<your_namespace>"}`.
 */
export function queryForms(payload) {
    var _a = serializer(_queryFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryFormsResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __queryForms(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.QueryForms',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryForms.fromReq = fromReq;
    __queryForms.__isAmbassador = true;
    return __queryForms;
}
/**
 * Deprecated on '2025-04-10'. Use CountFormsByFilter.
 * @deprecated It has been replaced with com.wixpress.forms.v4.FormSchemaService.CountFormsByFilter(), and will be removed on 2026-05-03.
 */
export function countForms(payload) {
    var _a = serializer(_countFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countFormsResponse, {}).fromJSON;
    function __countForms(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.CountForms',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countForms.fromReq = fromReq;
    __countForms.__isAmbassador = true;
    return __countForms;
}
/** Returns the total number of form schemas in the specified namespace that match the specified filter criteria. */
export function countFormsByFilter(payload) {
    var _a = serializer(_countFormsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countFormsByFilterResponse, {}).fromJSON;
    function __countFormsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.CountFormsByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/count-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countFormsByFilter.fromReq = fromReq;
    __countFormsByFilter.__isAmbassador = true;
    return __countFormsByFilter;
}
/**
 * Returns the total number of deleted form schemas in the specified namespace that match the specified filter criteria.
 * This counts form schemas in the trash bin, not permanently deleted form schemas.
 */
export function countDeletedForms(payload) {
    var _a = serializer(_countDeletedFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countDeletedFormsResponse, {}).fromJSON;
    function __countDeletedForms(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.CountDeletedForms',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/deleted-forms/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countDeletedForms.fromReq = fromReq;
    __countDeletedForms.__isAmbassador = true;
    return __countDeletedForms;
}
/**
 * Lists template extension as forms, filtered by namespace, its disabled status and name.
 * If specified, sorts forms in the desired order.
 */
export function listTemplateExtensions(payload) {
    var _a = serializer(_listTemplateExtensionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTemplateExtensionsResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __listTemplateExtensions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSchemaService.ListTemplateExtensions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/template-extensions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTemplateExtensions.fromReq = fromReq;
    __listTemplateExtensions.__isAmbassador = true;
    return __listTemplateExtensions;
}
/** Retrieves a list of form schemas that meet the specified criteria. */
export function listForms(payload) {
    var _a = serializer(_listFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFormsResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __listForms(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSchemaService.ListForms',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listForms.fromReq = fromReq;
    __listForms.__isAmbassador = true;
    return __listForms;
}
/**
 * Retrieves a deleted form schema by ID.
 *
 * This method retrieves form schemas that have been deleted and are in the trash bin but haven't yet been permanently removed.
 */
export function getDeletedForm(payload) {
    var _a = serializer(_getDeletedFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDeletedFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getDeletedForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSchemaService.GetDeletedForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/trash-bin/{formId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDeletedForm.fromReq = fromReq;
    __getDeletedForm.__isAmbassador = true;
    return __getDeletedForm;
}
/**
 * Retrieves a list of deleted form schemas given the provided paging, filtering, and sorting.
 *
 * This method lists form schemas that have were deleted and are in the trash bin but haven't yet been permanently removed.
 *
 * You must specify a namespace equality filter. For example, `"namespace:{"$eq":"<your_namespace>"}`.
 *
 * Refer to the [supported filters and sorting article](https://dev.wix.com/docs/api-reference/crm/forms/form-schemas/supported-filters-and-sorting) for a complete list of supported filters and sorting options.
 */
export function queryDeletedForms(payload) {
    var _a = serializer(_queryDeletedFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryDeletedFormsResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __queryDeletedForms(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.QueryDeletedForms',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/trash-bin/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryDeletedForms.fromReq = fromReq;
    __queryDeletedForms.__isAmbassador = true;
    return __queryDeletedForms;
}
/** Retrieves a list of deleted form schemas. */
export function listDeletedForms(payload) {
    var _a = serializer(_listDeletedFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDeletedFormsResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __listDeletedForms(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSchemaService.ListDeletedForms',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/trash-bin',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDeletedForms.fromReq = fromReq;
    __listDeletedForms.__isAmbassador = true;
    return __listDeletedForms;
}
/** Permanently removes deleted fields from a form schema. */
export function bulkRemoveDeletedField(payload) {
    var _a = serializer(_bulkRemoveDeletedFieldRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRemoveDeletedFieldResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __bulkRemoveDeletedField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.BulkRemoveDeletedField',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/fields/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRemoveDeletedField.fromReq = fromReq;
    __bulkRemoveDeletedField.__isAmbassador = true;
    return __bulkRemoveDeletedField;
}
/** Update extended fields of the form schema. */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {}).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.UpdateExtendedFields',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/{id}/extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/** Retrieves a list of configurations set by apps that provide the ability to create form schemas. For example, Wix Forms or Wix Bookings. */
export function listFormsProvidersConfigs(payload) {
    var _a = serializer(_listFormsProvidersConfigsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFormsProvidersConfigsResponse, {}).fromJSON;
    function __listFormsProvidersConfigs(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSchemaService.ListFormsProvidersConfigs',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/providers-config',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFormsProvidersConfigs.fromReq = fromReq;
    __listFormsProvidersConfigs.__isAmbassador = true;
    return __listFormsProvidersConfigs;
}
/**
 * Retrieves a summary of a form schema containing information about its fields.
 *
 * Use this method to get an overview of a form schema without all the detailed configuration information.
 */
export function getFormSummary(payload) {
    var _a = serializer(_getFormSummaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFormSummaryResponse, {}).fromJSON;
    function __getFormSummary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSchemaService.GetFormSummary',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/{formId}/summary',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFormSummary.fromReq = fromReq;
    __getFormSummary.__isAmbassador = true;
    return __getFormSummary;
}
/**
 * Creates form with migrated=true state
 * Used only for old forms migrations
 */
export function createMigratedForm(payload) {
    var _a = serializer(_createMigratedFormRequest, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMigratedFormResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _address: _address,
        _andCondition: _andCondition,
        _appEmbedData: _appEmbedData,
        _appointment: _appointment,
        _array: _array,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _arrayTypeArrayItems: _arrayTypeArrayItems,
        _audioData: _audioData,
        _background: _background,
        _backgroundImage: _backgroundImage,
        _boolean: _boolean,
        _breakPoint: _breakPoint,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _conditionNode: _conditionNode,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _design: _design,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _fieldsDisplayField: _fieldsDisplayField,
        _fieldsField: _fieldsField,
        _fieldsInputField: _fieldsInputField,
        _fieldsRichContentOptions: _fieldsRichContentOptions,
        _fileUpload: _fileUpload,
        _fixedPayment: _fixedPayment,
        _form: _form,
        _formField: _formField,
        _formFieldV2: _formFieldV2,
        _formLayout: _formLayout,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _group: _group,
        _image: _image,
        _imageData: _imageData,
        _inputField: _inputField,
        _inputFieldArrayType: _inputFieldArrayType,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _inputFieldNumberType: _inputFieldNumberType,
        _inputFieldObjectType: _inputFieldObjectType,
        _inputFieldPayment: _inputFieldPayment,
        _inputFieldScheduling: _inputFieldScheduling,
        _inputFieldWixFile: _inputFieldWixFile,
        _item: _item,
        _itemLayout: _itemLayout,
        _itemStyle: _itemStyle,
        _layoutData: _layoutData,
        _limitationRule: _limitationRule,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _mediaItem: _mediaItem,
        _metadata: _metadata,
        _multilineAddress: _multilineAddress,
        _nestedForm: _nestedForm,
        _node: _node,
        _number: _number,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _object: _object,
        _objectArray: _objectArray,
        _objectType: _objectType,
        _objectTypePropertiesType: _objectTypePropertiesType,
        _option: _option,
        _orCondition: _orCondition,
        _payment: _payment,
        _paymentInput: _paymentInput,
        _phoneInput: _phoneInput,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _repeater: _repeater,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _rule: _rule,
        _scheduling: _scheduling,
        _servicesCheckboxGroup: _servicesCheckboxGroup,
        _signature: _signature,
        _step: _step,
        _string: _string,
        _submitSettings: _submitSettings,
        _tags: _tags,
        _tagsOption: _tagsOption,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _validation: _validation,
        _validationArrayType: _validationArrayType,
        _validationArrayTypeArrayItems: _validationArrayTypeArrayItems,
        _validationNumberType: _validationNumberType,
        _validationObjectType: _validationObjectType,
        _validationObjectTypePropertiesType: _validationObjectTypePropertiesType,
        _video: _video,
        _videoData: _videoData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __createMigratedForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.CreateMigratedForm',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/forms/migrated',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMigratedForm.fromReq = fromReq;
    __createMigratedForm.__isAmbassador = true;
    return __createMigratedForm;
}
/** Bulk update tags on forms. */
export function bulkUpdateFormTags(payload) {
    var _a = serializer(_bulkUpdateFormTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateFormTagsResponse, {}).fromJSON;
    function __bulkUpdateFormTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.BulkUpdateFormTags',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/bulk/forms/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateFormTags.fromReq = fromReq;
    __bulkUpdateFormTags.__isAmbassador = true;
    return __bulkUpdateFormTags;
}
/** Bulk update tags on forms by filter. */
export function bulkUpdateFormTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateFormTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateFormTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateFormTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSchemaService.BulkUpdateFormTagsByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFormsV4FormSchemaServiceUrl({
                protoPath: '/v4/bulk/forms/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateFormTagsByFilter.fromReq = fromReq;
    __bulkUpdateFormTagsByFilter.__isAmbassador = true;
    return __bulkUpdateFormTagsByFilter;
}
//# sourceMappingURL=http.impl.js.map